// extracted by mini-css-extract-plugin
module.exports = {"Spinnerborder":"Spinner_Spinnerborder__WMLLO","spinner-border":"Spinner_spinner-border__3ayMx","center":"Spinner_center__3HCdZ"};